/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_OtherInputs */

const cs_integrations_other = /** @type {(inputs: Integrations_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další připojení`)
};

const en_integrations_other = /** @type {(inputs: Integrations_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other connections`)
};

/**
* | output |
* | --- |
* | "Other connections" |
*
* @param {Integrations_OtherInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_other = /** @type {((inputs?: Integrations_OtherInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_OtherInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_other(inputs)
	return cs_integrations_other(inputs)
});